//frontend/src/components/CourseCard.js
import React from 'react';
import { formatBobCurrency } from '../utilities/currency';
import { resolveMediaUrl } from '../utilities/media';

const CourseCard = ({ course, onClick }) => {
  return (
    <div 
      className="bg-white rounded-lg shadow-md overflow-hidden transition-transform hover:scale-105 hover:shadow-xl cursor-pointer"
      onClick={onClick}
    >
      <img
        src={resolveMediaUrl(course.thumbnail_url, 'default-thumbnail.jpg')}
        alt={course.title}
        className="w-full h-40 object-cover"
      />
      <div className="p-4">
        <h3 className="font-bold text-lg mb-2">{course.title}</h3>
        <p className="text-gray-600 text-sm mb-2">
          {course.instructor?.name || 'Instructor no especificado'}
        </p>
        <div className="flex justify-between items-center">
          <span className="font-bold text-lg">{formatBobCurrency(course.price)}</span>
        </div>
      </div>
    </div>
  );
};

export default CourseCard;
